export default "__VITE_ASSET__B6jE8b6a__"